import { VehicleDetail } from 'chariot/types';
import { Source } from 'core-lib/constants/sourceSKU';
import { isJSONString } from 'core-lib/utils/helpers';

export function serializeVehicleDetail(data: any): VehicleDetail {
  const brandModelMapping = isJSONString(data?.brand_model_mapping)
    ? JSON.parse(data?.brand_model_mapping)
    : data?.brand_model_mapping;

  return {
    id: data?.id,
    isLmv: !!data?.is_lmv,
    brandId: data?.manual_brand_id ?? brandModelMapping?.chariot_brand_id ?? data?.brand_id,
    brand: data?.manual_brand_id ? data?.brand : brandModelMapping?.brand_name,
    brandLogo: data?.manual_brand_id ? data?.brand_icon : brandModelMapping?.brand_icon,
    model: data?.manual_model_id ? data?.model : brandModelMapping?.model_name,
    modelId: data?.manual_model_id ?? brandModelMapping?.chariot_model_id ?? data?.model_id,
    vehicleImage: data?.manual_model_id
      ? data?.vehicle_image
      : (brandModelMapping?.model_image_url ?? data?.vehicle_image),
    license: data?.license,
    fuelType: data?.fuel_type,
    transmission: data?.transmission,
    label: data?.name,
    wheelCount: data?.wheel_count_int,
    registrationDate: data?.registration_date,
    color: data?.color,
    pollution: data?.pollution,
    isDefault: data?.default,
    bodyType: data?.body_type,
    extendedFuelType: data?.extended_fuel_type,
    projectId: data?.project_id,
    tagId: data?.tag_id,
    verificationStatus: data?.user_vehicle_status,
    docUploaded: data?.doc_uploaded,
    vehicleClass: data?.vehicle_class,
    ownerCount: data?.owner_count,
    financeName: data?.financer_name,
    variantId: data?.variant_id ?? data?.manual_variant_id,
    variantName: data?.variant_name,
    insuranceExpiryDate: data?.insurance_expiry_date,
    ownerName: data?.owner,
  };
}

export function formatVehicleList(list: any[], source = null) {
  const vehicles: VehicleDetail[] = [];
  // eslint-disable-next-line no-unused-expressions
  list?.forEach(item => {
    if (item && item?.id && item.license) {
      if (source === Source.Challan || item.wheel_count)
        vehicles.push(serializeVehicleDetail(item));
    }
  });

  return vehicles.sort((a, b) => b?.id - a?.id);
}
